import { Container, FadeUp } from "./primitives";

const LOGO = "/logo.png";

const COLS = [
  {
    t: "Company",
    items: [
      { l: "About", href: "/#solution" },
      { l: "Contact", href: "/contact" },
      { l: "Blog", href: "/#" },
      { l: "Careers", href: "/#" },
    ],
  },
  {
    t: "Product",
    items: [
      { l: "Features", href: "/#solution" },
      { l: "Pricing", href: "/#pricing" },
      { l: "Documentation", href: "/#" },
      { l: "Status", href: "/#" },
      { l: "API", href: "/#" },
    ],
  },
  {
    t: "Legal",
    items: [
      { l: "Privacy Policy", href: "/privacy-policy" },
      { l: "Terms of Service", href: "/terms-of-service" },
      { l: "Data Deletion", href: "/data-deletion" },
      { l: "Cookie Policy", href: "/privacy-policy#cookies" },
      { l: "Acceptable Use Policy", href: "/terms-of-service#acceptable-use" },
    ],
  },
  {
    t: "Support",
    items: [
      { l: "Help Center", href: "/contact" },
      { l: "Contact Support", href: "/contact" },
      { l: "Report Abuse", href: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 pt-24 pb-10 overflow-hidden">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <FadeUp className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl overflow-hidden ring-1 ring-white/10 bg-[#0F172A]">
                <img src={LOGO} alt="SocialLead AI" className="h-10 w-10 object-cover" />
              </span>
              <span className="font-display text-lg font-semibold">SocialLead <span className="text-white/40">AI</span></span>
            </div>
            <p className="mt-6 max-w-xs text-sm text-white/50 leading-relaxed">
              Turn social conversations into qualified customers. AI Discovery, CRM, Drafts, Approvals and Analytics — one platform.
            </p>
            <p className="mt-4 text-xs text-white/40 leading-relaxed">
              A product of <span className="text-white/70">PT Aimar Kala Sejahtera</span>.<br />
              <a href="https://about.sosmedlead.my.id" className="hover:text-white transition-colors">about.sosmedlead.my.id</a>
            </p>
            <div className="mt-8 flex items-center gap-2">
              <span className="chip">
                <span className="relative flex h-1.5 w-1.5">
                  <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-400" />
                </span>
                <span className="font-mono-x">All systems normal</span>
              </span>
            </div>
          </FadeUp>

          {COLS.map((col, i) => (
            <FadeUp key={col.t} delay={0.05 * i}>
              <div className="font-mono-x text-[10px] uppercase tracking-[0.22em] text-white/40">{col.t}</div>
              <ul className="mt-5 space-y-3">
                {col.items.map((it) => (
                  <li key={it.l}>
                    <a
                      href={it.href}
                      data-testid={`footer-link-${it.l.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-white/70 hover:text-white transition-colors"
                    >
                      {it.l}
                    </a>
                  </li>
                ))}
              </ul>
            </FadeUp>
          ))}
        </div>
      </Container>

      {/* Giant wordmark */}
      <FadeUp>
        <div className="mt-16 select-none pointer-events-none px-6 md:px-10">
          <div
            className="font-display leading-none tracking-[-0.05em] text-transparent bg-clip-text whitespace-nowrap"
            style={{
              fontSize: "clamp(3rem, 15vw, 15rem)",
              backgroundImage:
                "linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.05) 90%)",
            }}
          >
            SocialLead.
          </div>
        </div>
      </FadeUp>

      <Container>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} PT Aimar Kala Sejahtera. All rights reserved. SocialLead AI is a product operated by PT Aimar Kala Sejahtera.</div>
          <div className="flex items-center gap-4">
            <span className="font-mono-x">v3.2.1</span>
            <span>·</span>
            <a href="/privacy-policy" className="hover:text-white">Privacy</a>
            <span>·</span>
            <a href="/terms-of-service" className="hover:text-white">Terms</a>
            <span>·</span>
            <a href="/data-deletion" className="hover:text-white">Data deletion</a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
